import React from 'react';
import config from '../config';
import './LeaderboardList.css';

const normalizeMediaUrl = (rawUrl) => {
  if (!rawUrl || typeof rawUrl !== 'string') return '';
  if (rawUrl.startsWith('http')) return rawUrl;

  const base = config.API_BASE?.replace(/\/$/, '') || window.location.origin;
  return new URL(rawUrl, base).toString();
};

const extractMediaUrl = (profilePicture) => {
  if (!profilePicture) return '';

  const media = profilePicture?.data?.attributes || profilePicture?.data || profilePicture?.attributes || profilePicture;
  const formats = media?.formats || media?.attributes?.formats;
  const rawUrl =
    formats?.thumbnail?.url ||
    formats?.small?.url ||
    formats?.medium?.url ||
    media?.url ||
    media?.attributes?.url ||
    '';

  return normalizeMediaUrl(rawUrl);
};

const getDisplayName = (user) => {
  const displayName = String(user?.displayName || '').trim();
  if (displayName) return displayName;

  const firstName = String(user?.firstName || '').trim();
  const lastName = String(user?.lastName || '').trim();
  const fullName = [firstName, lastName].filter(Boolean).join(' ').trim();
  return fullName || user?.username || user?.email || '匿名';
};

const getInitial = (displayName) => {
  const safeName = String(displayName || '').trim();
  if (!safeName) return '?';
  return safeName.charAt(0).toUpperCase();
};

const rankClassName = (rank) => {
  if (rank === 1) return 'leaderboard-rank leaderboard-rank-gold';
  if (rank === 2) return 'leaderboard-rank leaderboard-rank-silver';
  if (rank === 3) return 'leaderboard-rank leaderboard-rank-bronze';
  return 'leaderboard-rank';
};

const LeaderboardList = ({ title, items = [], emptyText = '目前尚無排行榜資料', compact = false }) => {
  return (
    <div className={`leaderboard-card ${compact ? 'leaderboard-card-compact' : ''}`}>
      {title && <h5 className="leaderboard-title">{title}</h5>}

      {!items.length ? (
        <div className="leaderboard-empty">{emptyText}</div>
      ) : (
        <ul className="leaderboard-list" aria-label={title || '排行榜'}>
          {items.map((entry, index) => {
            const rank = Number(entry?.rank) || index + 1;
            const user = entry?.user || {};
            const displayName = getDisplayName(user);
            const avatarUrl = extractMediaUrl(user?.profilePicture);

            return (
              <li className="leaderboard-item" key={`${user?.id || 'user'}-${rank}-${entry?.count || 0}`}>
                <span className={rankClassName(rank)}>{rank}</span>

                <div className="leaderboard-avatar-wrap" aria-hidden="true">
                  {avatarUrl ? (
                    <img className="leaderboard-avatar" src={avatarUrl} alt="" loading="lazy" />
                  ) : (
                    <span className="leaderboard-avatar leaderboard-avatar-fallback">{getInitial(displayName)}</span>
                  )}
                </div>

                <div className="leaderboard-user-info">
                  <div className="leaderboard-name">{displayName}</div>
                </div>

                <div className="leaderboard-count">{entry?.count || 0} 次簽到</div>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
};

export default LeaderboardList;
